<template>
    <validation-observer :ref="formId">
        <b-row>
            <b-col cols="6">

                <b-form-group
                    :label="i18nT(`Date`)"
                    label-for="from"
                    class="required"
                >
                    <validation-provider
                        #default="{ errors }"
                        name="Date"
                        rules="required"
                    >
                        <date-picker
                            v-model="interviewFrom"
                            name="date"
                            :state="errors.length > 0 ? false:null"
                        ></date-picker>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>

            </b-col>

            <b-col cols="6">
                <b-form-group
                    :label="i18nT(`Timezone`)"
                    label-for="to"
                >
                    <b-form-select
                        v-model="interviewTimezone"
                        :options="allTimeZones"
                        :state="null"
                        placeholder=""></b-form-select>
                </b-form-group>
            </b-col>

            <b-col cols="6">
                <b-form-group
                    :label="i18nT(`Interview start time`)"
                    label-for="from"
                    class="required"
                >
                    <validation-provider
                        #default="{ errors }"
                        name="Date"
                        rules="required"
                    >
                        <b-form-timepicker
                            v-model="interviewFromTime"
                            minutes-step="15"
                            :state="errors.length > 0 ? false:null">
                        </b-form-timepicker>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>

            <b-col cols="6">
                <b-form-group
                    :label="i18nT(`Duration`)"
                    label-for="duration"
                    class="required"
                >
                    <validation-provider
                        #default="{ errors }"
                        name="duration"
                        rules="required"
                    >
                        <b-form-select
                            v-model="duration"
                            :options="durations"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>

        <b-form-group
            :label="i18nT(`Location`)"
            label-for="Location"
            class="required"
        >
            <validation-provider
                #default="{ errors }"
                name="Location"
                rules="required"
            >
                <b-form-input
                    v-model="interviewLocation"
                    :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
        </b-form-group>

        <b-form-group
            :label="i18nT(`Participants`)+` (`+i18nT(`Ctrl+click to select multiple`)+`) `"
            label-for="with"
            class="required"
        >
            <validation-provider
                #default="{ errors }"
                name="With"
                rules="required"
            >
                <b-form-select
                    v-model="interviewWith"
                    :multiple="true"
                    :options="candidateDetails.staff.map((staff) => ({value: staff.Id, text: staff.Label}))"
                    :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
        </b-form-group>

        <b-form-group
            :label="i18nT(`Internal comments`)"
            label-for="comment"
        >
            <b-form-textarea
                id="textarea-interviewComment"
                v-model="interviewComment"
                :placeholder="i18nT(`Private notes (the candidate doesn't see these)`)"
                rows="3"
            />

        </b-form-group>

        <b-button
            size=""
            variant="primary"
            @click="publishInterview"
        >
            {{ i18nT(`Publish`) }}
        </b-button>

    </validation-observer>
</template>

<script>

import {BButton, BCol, BFormGroup, BFormInput, BFormSelect, BFormTextarea, BFormTimepicker, BRow} from "bootstrap-vue";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import DatePicker from '@core/components/DatePicker.vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {dictToSelectArray} from "@core/utils/utils";
import useAuth from '@/auth/useAuth';

export default  {
    name: "InterviewAddForm",
    components: {
        BFormGroup,
        BFormSelect,
        BFormInput,
        BFormTextarea,
        BFormTimepicker,
        BButton,
        ValidationProvider,
        ValidationObserver,
        BCol,
        BRow,
        DatePicker
    },
    props: {
        formId: {
            type: String,
            default: 'interviewForm'
        },
        candidateDetails: {
            type: Object,
            default:  {
                current_application: {},
                staff: []
            }
        },

    },
    created(){
        this.$http.get(`system/interviewDurations`).then(({data}) => {
            this.durations = dictToSelectArray(data.data)
        });

        this.$http.get(`system/timezones`).then(({data}) => {
            this.allTimeZones = dictToSelectArray(data.data)
        });

        const curWorkspace = useAuth.getCurWorkspace();
        if(curWorkspace && curWorkspace.MainTimezone){
            this.interviewTimezone = curWorkspace.MainTimezone;
        }

    },
    data() {
        return {
            interviewTimezone: 'GMT+00:00',
            interviewFrom: '',
            interviewFromTime: '08:00:00',
            interviewTo: '',
            interviewWith: [],
            interviewLocation: '',
            interviewComment: '',
            duration: 30,
            durations: [],
            allTimeZones: [
                { text: '(GMT-12:00) International Date Line West', value: 'GMT-12:00' },
                { text: '(GMT-11:00) Niue',                        value: 'GMT-11:00' },
                { text: '(GMT-10:00) Honolulu',                    value: 'GMT-10:00' },
                { text: '(GMT-09:00) Anchorage',                   value: 'GMT-09:00' },
                { text: '(GMT-08:00) Los Angeles (US Pacific)',    value: 'GMT-08:00' },
                { text: '(GMT-07:00) Denver (US Mountain)',        value: 'GMT-07:00' },
                { text: '(GMT-06:00) Chicago (US Central)',        value: 'GMT-06:00' },
                { text: '(GMT-05:00) New York (US Eastern)',       value: 'GMT-05:00' },
                { text: '(GMT-04:00) Caracas',                     value: 'GMT-04:00' },
                { text: '(GMT-03:00) São Paulo',                   value: 'GMT-03:00' },
                { text: '(GMT-02:00) South Georgia & the South Sandwich Islands', value: 'GMT-02:00' },
                { text: '(GMT-01:00) Azores',                      value: 'GMT-01:00' },
                { text: '(GMT+00:00) London, Lisbon',              value: 'GMT+00:00' },
                { text: '(GMT+01:00) Berlin, Paris, Rome',         value: 'GMT+01:00' },
                { text: '(GMT+02:00) Athens, Helsinki',            value: 'GMT+02:00' },
                { text: '(GMT+03:00) Moscow, Istanbul',            value: 'GMT+03:00' },
                { text: '(GMT+04:00) Dubai',                       value: 'GMT+04:00' },
                { text: '(GMT+05:00) Mumbai',                      value: 'GMT+05:00' },
                { text: '(GMT+06:00) Dhaka',                       value: 'GMT+06:00' },
                { text: '(GMT+07:00) Bangkok',                     value: 'GMT+07:00' },
                { text: '(GMT+08:00) Beijing, Singapore',          value: 'GMT+08:00' },
                { text: '(GMT+09:00) Tokyo',                       value: 'GMT+09:00' },
                { text: '(GMT+10:00) Sydney',                      value: 'GMT+10:00' },
                { text: '(GMT+11:00) Nouméa',                      value: 'GMT+11:00' },
                { text: '(GMT+12:00) Auckland',                    value: 'GMT+12:00' },
                { text: '(GMT+13:00) Nukuʻalofa',                  value: 'GMT+13:00' },
                { text: '(GMT+14:00) Kiritimati',                  value: 'GMT+14:00' }
            ]
        }
    },
    methods: {
        resetForm(){

            this.interviewFrom = '';
            this.interviewFromTime = '08:00:00';
            const curWorkspace = useAuth.getCurWorkspace();
            this.interviewTimezone = curWorkspace && curWorkspace.MainTimezone ? curWorkspace.MainTimezone : 'GMT+00:00';
            this.interviewTo = '';
            this.interviewWith = [];
            this.interviewLocation = '';
            this.interviewComment = '';
            this.duration = 30;
            this.$refs[this.formId].reset()
        },
        publishInterview() {
            this.$refs[this.formId].validate().then(success => {

                if (success) {
                    // eslint-disable-next-line
                    const formData = new FormData()
                    formData.append(
                        'application_id',
                        this.candidateDetails.current_application.Id
                    )
                    // formData.append('interview_when', `${this.interviewFrom} - ${this.interviewTo}`)

                    formData.append('StartDate', this.interviewFrom+' '+this.interviewFromTime)
                    formData.append('Duration', this.duration)
                    formData.append('interview_with', this.interviewWith)
                    formData.append('interview_location', this.interviewLocation)
                    formData.append('interview_comment', this.interviewComment)
                    formData.append('interview_timezone', this.interviewTimezone)

                    this.$http
                        .post('candidates/addInterview', formData)
                        .then(res => {
                            this.$toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                    title: this.successMessage(res),
                                    icon: 'InfoIcon',
                                    variant: 'success'
                                }
                            })

                           this.resetForm();
                           this.$emit('added', res.data.data)
                        })
                        .catch(err => {
                            this.$toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                    title: this.errorMessage(err),
                                    icon: 'AlertTriangleIcon',
                                    variant: 'danger'
                                }
                            })
                        })
                }
                else {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: this.i18nT('Please fill all required fields'),
                            icon: 'AlertTriangleIcon',
                            variant: 'danger'
                        }
                    })
                }
            })
        },
    }
}
</script>


<style scoped lang="scss">

</style>
